import React from 'react';

import { Drawer, DrawerOverlay } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledDrawer = styled(Drawer)`
  background-color: white;
`;

export const BottomDrawer = ({ isOpen = false, onClose, children, ...props }) => (
  <StyledDrawer isOpen={isOpen} placement="bottom" onClose={onClose} {...props}>
    <DrawerOverlay />
    {children}
  </StyledDrawer>
);
